import React from 'react';
interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/aSZYkg3kSqRUsibX6SGQR4/ChatGPT_Image_Jun_14,_2026,_06_55_09_PM.png';
export function Logo({
  size = 'md',
  showText = true,
  className = ''
}: LogoProps) {
  // Heights for the full lockup (mark + wordmark) vs. mark-only crop
  const heights = {
    sm: showText ? 36 : 30,
    md: showText ? 48 : 42,
    lg: showText ? 68 : 60
  };
  const height = heights[size];
  // The uploaded asset is a wide lockup with generous whitespace.
  // When showText is false we crop to just the gradient "T" mark on the left.
  return <div className={`flex items-center ${className}`} data-id="element-1944">
      <div className="overflow-hidden" style={{
      height,
      width: showText ? height * 3.6 : height
    }} data-id="element-1945">
        <img src={LOGO_SRC} alt="TALAB" className="object-cover" style={{
        height,
        width: showText ? height * 3.6 : height * 3.6,
        objectPosition: showText ? 'center' : '8% center'
      }} data-id="element-1946" />
      </div>
    </div>;
}